/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import { Link } from 'react-router-dom';
import * as React from 'react';

export class SongLink extends React.PureComponent<React.PropsWithChildren<{songId: string}>> {

    render() {
        return (
            <Link to={`/playlist-admin/song/${this.props.songId}`} >{this.props.children}</Link>
        );
    }

}